import { useColorScheme } from 'react-native';

import { ColorSchemeName } from '../components/ColorScheme';

export function useSystemColorScheme(): ColorSchemeName {
  return useColorScheme()!;
}
